var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 841.89 595.28",
    style: {
      enableBackground: "new 0 0 841.89 595.28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#111827;}\r\n\t.st1{fill:#3B82F6;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M603.59,253.64c-6.47,3-13.67,4.63-21.26,4.63c-28.5,0-51.6-23.1-51.6-51.56c0-17.66,8.87-33.22,22.37-42.52 c-33.95-33.6-80.62-54.39-132.18-54.39c-16.16,0-31.89,2.06-46.85,5.87c5.57,9.09,8.79,19.76,8.79,31.2 c0,33.05-26.83,59.83-59.88,59.83c-20.4,0-38.4-10.2-49.2-25.8c-25.46,32.06-40.67,72.65-40.67,116.75 c0,66.26,34.29,124.47,86.11,157.9c9.39-10.11,22.8-16.46,37.76-16.46c26.53,0,48.43,20.1,51.26,45.95c4.16,0.3,8.4,0.43,12.69,0.43 c103.76,0,187.86-84.09,187.86-187.81C608.78,282.53,606.98,267.74,603.59,253.64z M283.69,339.96c-23.36,0-42.3-18.94-42.3-42.3 c0-23.4,18.94-42.35,42.3-42.35c23.36,0,42.3,18.94,42.3,42.35C325.99,321.02,307.04,339.96,283.69,339.96z M395.94,275.03 c-10.89,0-19.72-8.83-19.72-19.72c0-10.89,8.83-19.72,19.72-19.72c10.89,0,19.72,8.83,19.72,19.72 C415.65,266.2,406.82,275.03,395.94,275.03z M490.23,403.48c-17.57,0-31.76-14.23-31.76-31.76c0-17.53,14.19-31.76,31.76-31.76 c17.53,0,31.76,14.23,31.76,31.76C521.99,389.25,507.76,403.48,490.23,403.48z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.81472c2ed7667f4bd9fac074e95124e9.svg";
export { ForwardRef as ReactComponent };